module.exports = {"reportingServiceUrl":"https://reporting-service.protransport.app/","documentServiceUrl":"https://file-service.rtspro.com/"};